import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { UserOption } from './user-option/UserOption';

/**
 * # Chatbot
 *
 * 챗봇용 모델
 */

export const ChatbotResponse = types.model('chatbotResponse', {
  message: types.maybeNull(types.array(types.string)),
});
type TChatbotResponse = Instance<typeof ChatbotResponse>;
export interface IChatbotResponse extends TChatbotResponse {}
export const createChatbotResponse = () => types.optional(ChatbotResponse, {} as TChatbotResponse);

export const Question = types.model('question', {
  conv_type: types.maybeNull(types.string),
  user_option: types.maybeNull(UserOption),
  chatbot_response: types.maybeNull(ChatbotResponse),
});
type TQuestion = Instance<typeof Question>;
export interface IQuestion extends TQuestion {}
export const createQuestion = () => types.optional(Question, {} as TQuestion);

export const Chatbot = types
  .model('Chatbot')
  // --------------------------------------------------------------------------
  .props({
    conv_type: types.maybeNull(types.string),
    user_option: types.maybeNull(UserOption),
    chatbot_response: types.maybeNull(ChatbotResponse),
    questions: types.maybeNull(types.array(Question)),
    selectedOptions: types.maybeNull(types.array(types.string)), // 사용자 선택 value 값
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model chatbot --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IChatbotSnapshot>) => {
      const newProps = { ...self, ...props } as IChatbot;
      (Object.keys(newProps) as TChatbotKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TChatbot = Instance<typeof Chatbot>;
type TChatbotSnapshot = SnapshotOut<typeof Chatbot>;

export interface IChatbot extends TChatbot {}
export type TChatbotKeys = keyof TChatbotSnapshot & string;
export interface IChatbotSnapshot extends TChatbotSnapshot {}
export const createChatbot = () => types.optional(Chatbot, {} as TChatbot);
